import React from "react";
import { useNavigate } from "react-router-dom";
import "./ChatTile.css";

interface ChatTileProps {
    id: string;
    chatTopic: string;
    chatText: string;
    creationDate: string;
}

function ChatTile({ id, chatTopic, chatText, creationDate }: ChatTileProps) {
    const navigate = useNavigate();

    const handleClick = () => {
        const chatData = { id, chatTopic, chatText, creationDate };
        localStorage.setItem("selectedChat", JSON.stringify(chatData));
        navigate(`/chat/${id}`);
    };

    return (
        <div className="chat-tile-body" onClick={handleClick}>
            <div className="chat-tile-topic">
                <p>{chatTopic}</p>
                <p>{creationDate}</p>
            </div>
        </div>
    );
}

export default ChatTile;
